import { jsx as f } from "react/jsx-runtime";
import { c as a } from "react/compiler-runtime";
import p from "moment-timezone";
import u from "@mui/icons-material/KeyboardDoubleArrowLeftOutlined";
import x from "@mui/icons-material/KeyboardDoubleArrowRightOutlined";
import { Box as b } from "@mui/material";
import { styles as k } from "./DateTimeSelect.style.js";
const D = (d) => {
  const o = a(13), {
    direction: e,
    distance: t,
    color: n,
    onSeek: s
  } = d;
  let l;
  o[0] !== t ? (l = p.duration(t, "seconds").humanize(), o[0] = t, o[1] = l) : l = o[1];
  const c = `Seek ${l} ${e === -1 ? "backward" : "forward"}`;
  let r;
  o[2] !== e || o[3] !== t || o[4] !== s ? (r = () => s(e, t), o[2] = e, o[3] = t, o[4] = s, o[5] = r) : r = o[5];
  let i;
  o[6] !== n || o[7] !== e ? (i = e === -1 ? /* @__PURE__ */ f(u, { sx: {
    color: n
  } }) : /* @__PURE__ */ f(x, { sx: {
    color: n
  } }), o[6] = n, o[7] = e, o[8] = i) : i = o[8];
  let m;
  return o[9] !== c || o[10] !== r || o[11] !== i ? (m = /* @__PURE__ */ f(b, { sx: k.arrowIcon, title: c, onClick: r, children: i }), o[9] = c, o[10] = r, o[11] = i, o[12] = m) : m = o[12], m;
};
export {
  D as Seek
};
